import { FormattedMessage } from 'react-intl';

import { AwaitingFundsIllustrationSVG } from '../../../svgComponents/awaitingFundsIllustrationSVG';
import { StateView } from '../../pageStructure/stateView/StateView';

export const AwaitingFundsView = () => {
    return (
        <StateView
            image={<AwaitingFundsIllustrationSVG />}
            headerMessage={
                <FormattedMessage
                    id="_.awaiting_funds_view.title"
                    defaultMessage="Your funds are on their way!"
                />
            }
            descriptionMessage={
                <FormattedMessage
                    id="_.awaiting_funds_view.subtitle"
                    defaultMessage="Thank you for completing your application, we're processing the transfer of funds and they'll land in your account as soon as we've processed the transfer."
                />
            }
        />
    );
};
